import { render, staticRenderFns } from "./DetailPurchasesByCar.vue?vue&type=template&id=c8e5fd9a&scoped=true&"
import script from "./DetailPurchasesByCar.vue?vue&type=script&lang=ts&"
export * from "./DetailPurchasesByCar.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPurchasesByCar.vue?vue&type=style&index=0&id=c8e5fd9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e5fd9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VContainer,VProgressLinear})
